/*----------------------IMAGES-TYPES----------------------------*/
export const RANDOMIZE_IMAGE = 'RANDOMIZE_IMAGE'
    /*----------------------WHEATHER-TYPES--------------------------*/
export const SET_POSITION = 'SET_POSITION'
export const REWRITE_POSITION = 'REWRITE_POSITION'
export const HANDLE_LON_LAT = 'HANDLE_LON_LAT'
export const FETCH_BY_CITY_NAME = 'FETCH_BY_CITY_NAME'
export const FETCH_BY_NAME_5_DAYS = 'FETCH_BY_NAME_5_DAYS'
export const FETCH_MINUTELY = 'FETCH_MINUTELY'
export const FETCH_HOURLY = 'FETCH_HOURLY'
export const FETCH_DAILY = 'FETCH_DAILY'
export const FETCH_ALERTS = 'FETCH_ALERTS'
export const WHEATHER_MAP = 'WHEATHER_MAP'
    /*----------------------TODO-TYPES--------------------------*/
export const SET_TODO = 'SET_TODO'
export const SET_COMPLETED = 'SET_COMPLETED'
export const SET_DESCRIPTION = 'SET_DESCRIPTION'
export const ADD_TODO = 'ADD_TODO'
export const EDIT_TODO = 'EDIT_TODO'
export const SAVE_TODO = 'SAVE_TODO'
export const REMOVE_TODO = 'REMOVE_TODO'
export const CLEAR_TODO = 'CLEAR_TODO'